<template>
  <div>
    <filter-for-grid
      :views-dropdown="false"
      :filters="[]"
      :client-session="true"
      :query-params.sync="query_params"
      @apartmentChanged="apartmentSelect"
      @objectChanged="objectSelect"
      @sessionEnd="sessionEnd"
    />
    <b-card>
      <vue-selecto
        :data="GET_CHECKERBOARD_LAYOUT"
        :sidebar="true"
        :filter="query_params"
        @flatSelected="openRightSidebar"
      />
    </b-card>
    <right-sidebar
      v-model="right_sidebar"
      :item="selected_flat"
      :flat-choosing="false"
      @photoClicked="showInLargeSize"
      @bookingFlat="bookingFlat"
      @commercialOffer="commercialOffer"
      @flatChoose="flatChosen"
      @interested="interestedIn"
      @makeContract="pushToContract"
    />
    <left-sidebar
      v-model="left_sidebar"
      :image="selected_image"
    />
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import filterForGrid from '../MyObjects/Apartments/components/filterForGrid.vue'
import vueSelecto from '@/components/vueSelecto.vue'
import rightSidebar from '../MyObjects/Apartments/components/flatSidebar.vue'
import leftSidebar from '../MyObjects/Apartments/components/leftImageSidebar.vue'
import saleSteps from '@/mixins/salesBpmSteps'

export default {
  components: {
    BCard,
    filterForGrid,
    vueSelecto,
    rightSidebar,
    leftSidebar,
  },
  mixins: [saleSteps],
  data() {
    return {
      right_sidebar: false,
      left_sidebar: false,
      selected_image: '',
      selected_flat: {
        current_status: {
          title: {},
        },
        areas: [],
      },
      query_params: {
        rooms_count_list: [],
        total_area_start: '',
        total_area_end: '',
        total_price_end: '',
        total_price_start: '',
        current_status: [],
      },
      rc_object: null,
      apartment: null,
    }
  },
  computed: {
    ...mapGetters('flats', ['GET_ONE_FLAT']),
    ...mapGetters('apartments', ['GET_CHECKERBOARD_LAYOUT']),
    getSelectedClientInfo() {
      if (sessionStorage.getItem('selected_client')) {
        return JSON.parse(sessionStorage.getItem('selected_client'))
      }
      return undefined
    },
    getSalesBpmStep() {
      if (sessionStorage.getItem('sales_bpm_step')) {
        return sessionStorage.getItem('sales_bpm_step')
      }
      return undefined
    },
    getSelectedFlatId() {
      return sessionStorage.getItem('product_id')
    },
  },
  mounted() {
    this.FETCH_OBJECTS({ partial: true })
    if (!this.getSelectedClientInfo) {
      this.$router.push({ name: 'clients-demo-page' })
    }
  },
  destroyed() {
    this.SET_APARTMENT_CHECKERBOARD_LAYOUT([])
  },
  methods: {
    ...mapActions('flats', ['FETCH_ONE_FLAT', 'EDIT_FLAT']),
    ...mapActions('apartments', ['FETCH_APARTMENTS_BY_OBJECT', 'FETCH_APARTMENT_CHECKERBOARD_LAYOUT']),
    ...mapActions('objects', ['FETCH_OBJECTS']),
    ...mapActions('kanban', ['ADD_NEW_LID']),
    ...mapMutations('apartments', ['SET_APARTMENT_CHECKERBOARD_LAYOUT']),
    showInLargeSize(url) {
      this.selected_image = url
      this.left_sidebar = true
    },
    openRightSidebar(flat) {
      this.FETCH_ONE_FLAT(flat.id).then(() => {
        this.selected_flat = this.GET_ONE_FLAT
      })
      this.right_sidebar = true
    },
    flatChosen() {

    },
    objectSelect(object_id) {
      this.rc_object = object_id
      if (object_id) {
        this.FETCH_APARTMENTS_BY_OBJECT({ id: object_id })
      }
    },
    apartmentSelect(apartment_id) {
      if (apartment_id) {
        this.apartment = apartment_id
        this.FETCH_APARTMENT_CHECKERBOARD_LAYOUT(apartment_id)
      }
    },
    bookingFlat(id) {
      if (id) {
        sessionStorage.setItem('product_id', id)
        sessionStorage.setItem('sales_bpm_step', this.sale_bpm_steps.booked)
        // this.ADD_NEW_LID({ client: this.getSelectedClientInfo.id, product: [id], current_step: this.sale_bpm_steps.booked }).then(() => {
        this.$_successToast('Добавлено новый лид')
        // })
        // this.EDIT_FLAT({ id, current_status: 2 }).then(() => {
        //   this.$_successToast('Успешно забронирован')
        //   this.apartmentSelect(this.apartment)
        //   this.openRightSidebar({ id })
        // })
      }
    },
    interestedIn(flat_id) {
      sessionStorage.setItem('product_id', flat_id)
      // this.ADD_NEW_LID({ client: this.getSelectedClientInfo.id, product: [flat_id] }).then(() => {
      this.$_successToast('Добавлено новый лид')
      // })
    },
    commercialOffer(flat_id) {
      sessionStorage.setItem('product_id', flat_id)
      sessionStorage.setItem('sales_bpm_step', this.sale_bpm_steps.kp)
      // this.ADD_NEW_LID({ client: this.getSelectedClientInfo.id, product: [flat_id], current_step: this.sale_bpm_steps.kp }).then(() => {
      this.$_successToast('Добавлено новый лид на рассмотрение КП')
      // })
    },
    pushToContract(flat) {
      const contractSubject = {
        flat: flat.id,
        rc_object: this.rc_object,
        apartment: this.apartment,
        section: flat.section,
        stage: flat.stage,
      }
      this.$router.push({ name: 'new-contract', params: { contractSubject } })
    },
    sessionEnd() {
      this.ADD_NEW_LID({ client: this.getSelectedClientInfo.id, product: [this.getSelectedFlatId], current_step: this.getSalesBpmStep && this.getSalesBpmStep }).then(() => {
        sessionStorage.removeItem('selected_client')
        this.$_successToast(this.$t('clients.added_new_lead'))
        sessionStorage.removeItem('product_id')
      })
      // if (Number(this.getSalesBpmStep) === this.sale_bpm_steps.booked) {
      //   this.EDIT_FLAT({ id: this.getSelectedFlatId, current_status: 2 }).then(() => {
      //     this.$_successToast(this.$t('clients.booking_success'))
      //     sessionStorage.removeItem('sales_bpm_step')
      //     this.apartmentSelect(this.apartment)
      //   })
      // }
      this.$router.push({ name: 'clients-demo-page' })
    },
  },
}
</script>

<style>

</style>
